import { createUseStyles } from 'react-jss'
import { darkGrey, lightGrey } from '../../../styles/const/colors'
import { defaultBorderRadius } from '../../../styles/const/common'

const useStyles = createUseStyles({
  radioBlock: {
    position: 'relative',
    display: 'block',
    padding: '15px 19px',
    border: {
      style: 'solid',
      width: 1,
      radius: defaultBorderRadius,
      color: lightGrey
    },
    backgroundColor: 'white',
    '&:not(:last-child)': {
      marginBottom: 8
    }
  },

  radioBody: {
    marginTop: 16,
    paddingBottom: 4,
    '& p': {
      marginTop: 8,
      color: darkGrey,
      '& a': {
        color: 'inherit'
      }
    },
    '& .checkbox': {
      marginLeft: 0,
      marginTop: 12
    },
    '& > *:last-child': {
      marginBottom: 0
    }
  }
})

export default useStyles
